import { types } from './crudDinamicoDefinicao.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'crudDinamicoDefinicao',
  booleanFilter: {},
  showHideColumns: [
    {
      label: 'Seleção',
      value: {
        field: 'multiselect',
        header: 'Seleção',
        columnKey: 'multiselect',
        visible: false,
      },
    },
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        sortable: true,
        filter: true,
        columnSortField: 'oid',
        visible: true,
      },
    },
    {
      label: 'Chave',
      value: {
        field: 'chave',
        header: 'Chave',
        columnKey: 'chave',
        sortable: true,
        filter: true,
        columnSortField: 'chave',
        visible: true,
      },
    },
    {
      label: 'Nome',
      value: {
        field: 'nome',
        header: 'Nome',
        columnKey: 'nome',
        sortable: true,
        filter: true,
        columnSortField: 'nome',
        visible: true,
      },
    },
    {
      label: 'Tabela',
      value: {
        field: 'tabela',
        header: 'Tabela',
        columnKey: 'tabela',
        sortable: true,
        filter: true,
        columnSortField: 'tabela',
        visible: true,
      },
    },
    {
      label: 'Ativo',
      value: {
        field: 'ativo',
        header: 'Ativo',
        columnKey: 'ativo',
        sortable: true,
        filter: true,
        columnSortField: 'ativo',
        visible: true,
      },
    },
  ],
  columns: [],
  currentRecord: {
    oid: '',
    chave: '',
    nome: '',
    tabela: '',
    definicao: '',
    ativo: true,
  },
  messages: null,
  selectedFilters: [],
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDCrudDinamicoDefinicaoReducer(state, action) {
  if (state) {
    // labels genéricos do toolbar + escopo crudDinamico do dicionário;
    // exige "crudDinamico" na lista de telas do PhoenixLoginService.getAppLabels (BE)
    state.messages = storage.getAppLabels('crudDinamico')
  }
  return reducer.execute(state, action)
}
